import {
  User,
  SlidersHorizontal,
  ShieldCheck,
  Bell,
  MapPin,
  LifeBuoy,
  Scale,
  Info,
  UserCog,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface SettingsNavItem {
  /** Translation key for the category label (resolve with `t()`). */
  labelKey: string;
  /** Translation key for the one-line description. */
  descriptionKey: string;
  icon: LucideIcon;
  to: string;
  /** `end` for the index route so it isn't marked active on children. */
  end?: boolean;
}

/** The nine top-level settings categories, in display order. */
export const SETTINGS_NAV: SettingsNavItem[] = [
  { labelKey: 'settingsNav.profile', descriptionKey: 'settingsNav.profileDesc', icon: User, to: '/app/settings', end: true },
  { labelKey: 'settingsNav.preferences', descriptionKey: 'settingsNav.preferencesDesc', icon: SlidersHorizontal, to: '/app/settings/preferences' },
  { labelKey: 'settingsNav.security', descriptionKey: 'settingsNav.securityDesc', icon: ShieldCheck, to: '/app/settings/security' },
  { labelKey: 'settingsNav.notifications', descriptionKey: 'settingsNav.notificationsDesc', icon: Bell, to: '/app/settings/notifications' },
  { labelKey: 'settingsNav.location', descriptionKey: 'settingsNav.locationDesc', icon: MapPin, to: '/app/settings/location' },
  { labelKey: 'settingsNav.support', descriptionKey: 'settingsNav.supportDesc', icon: LifeBuoy, to: '/app/settings/support' },
  { labelKey: 'settingsNav.legal', descriptionKey: 'settingsNav.legalDesc', icon: Scale, to: '/app/settings/legal' },
  { labelKey: 'settingsNav.about', descriptionKey: 'settingsNav.aboutDesc', icon: Info, to: '/app/settings/about' },
  { labelKey: 'settingsNav.account', descriptionKey: 'settingsNav.accountDesc', icon: UserCog, to: '/app/settings/account' },
];
